import {BasicReducerState, initialReducerState} from "../BasicReducerState";
import {Nullable} from "../../models/common/Nullable";
import {
    errorFetchingRequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {
    ContractorContactActionTypes,
    FETCH_CONTRACTOR_CONTACTS,
    FETCH_CONTRACTOR_CONTACTS_ERROR,
    FETCH_CONTRACTOR_CONTACTS_SUCCESS
} from "../../actions/contractors/ContractorContactActions";
import {ContractorContact} from "../../models/contractor/ContractorContact";


export interface ContractorContactState {
    [key: number]: BasicReducerState< Nullable< ContractorContact[]>, Nullable< ContractorContact >>
}



export function ContractorContactReducer(
    state: ContractorContactState = {},
    action: ContractorContactActionTypes
) {

    switch (action.type) {
        case FETCH_CONTRACTOR_CONTACTS:
            return {
                ...state,
                [ action.contractorId.rawValue ]: {
                    ...state[ action.contractorId.rawValue ],
                    entries: {
                        current: null,
                        request: startFetchingRequestState()
                    },
                }
            };
        case FETCH_CONTRACTOR_CONTACTS_SUCCESS:
            return {
                ...state,
                [ action.contractorId.rawValue ]: {
                    ...state[ action.contractorId.rawValue ],
                    totalEntries: action.payload.totalEntries,
                    entries: {
                        current: action.payload.entries,
                        request: successFetchingRequestState()
                    }
                }
            };
        case FETCH_CONTRACTOR_CONTACTS_ERROR:
            return {
                ...state,
                [ action.contractorId.rawValue ]: {
                    ...state[ action.contractorId.rawValue ],
                    entries: {
                        ...state[ action.contractorId.rawValue ].entries,
                        request: errorFetchingRequestState(action.error)
                    }
                }

            };
        default:
            return state;
    }
}